import type { FolderColor } from "../forms/FolderColorPicker";

type FolderCreateFormProps = {
  name: string;
  color: string;
  colors: FolderColor[];
  placeholder: string;
  addLabel: string;
  cancelLabel: string;
  onChangeName: (value: string) => void;
  onChangeColor: (value: string) => void;
  onSubmit: () => void;
  onCancel: () => void;
};

export default function FolderCreateForm({
  name,
  color,
  colors,
  placeholder,
  addLabel,
  cancelLabel,
  onChangeName,
  onChangeColor,
  onSubmit,
  onCancel,
}: FolderCreateFormProps) {
  return (
    <div className="bg-gray-50 rounded-xl p-4 border border-gray-200">
      <div className="mb-3">
        <input
          type="text"
          value={name}
          onChange={(e) => onChangeName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") onSubmit();
            if (e.key === "Escape") onCancel();
          }}
          placeholder={placeholder}
          className="w-full px-3 py-2.5 bg-white border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
          autoFocus
        />
      </div>
      <div className="flex items-center gap-2 mb-3">
        {colors.map((c) => (
          <button
            key={c.value}
            onClick={() => onChangeColor(c.value)}
            className={`w-7 h-7 rounded-full transition-all cursor-pointer ${
              color === c.value
                ? "ring-2 ring-offset-2 ring-gray-400 scale-110"
                : ""
            }`}
            style={{ backgroundColor: c.value }}
            title={c.label}
          />
        ))}
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={onSubmit}
          className="flex-1 px-3 py-2 bg-indigo-500 hover:bg-indigo-600 text-white rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap"
        >
          {addLabel}
        </button>
        <button
          onClick={onCancel}
          className="flex-1 px-3 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap"
        >
          {cancelLabel}
        </button>
      </div>
    </div>
  );
}
